import React, {FC, useEffect, useState} from "react";
import Heading from "components/Heading/Heading";
import { PostDataType } from "data/types";
import Card11 from "components/Card11/Card11";
import Card9 from "components/Card9/Card9";
import { DEMO_POSTS } from "data/posts";
import {
  collection,
  collectionGroup,
  doc,
  DocumentData,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  where
} from "firebase/firestore";
import {auth, db} from "../../configs/firebase-config";
import {checkBookmark, checkPostLiked} from "../../global/Functions";


export interface SingleRelatedPostsProps {
  relatedPosts?: PostDataType[];
  moreFromAuthorPosts?: PostDataType[];
  author?: string;
  postData?: any;
}

const demoRelated: PostDataType[] = DEMO_POSTS.filter(
    (_, i) => i >= 10 && i < 14
);
const demoMoreFromAuthor: PostDataType[] = DEMO_POSTS.filter(
    (_, i) => i >= 14 && i < 18
);

const SingleRelatedPosts: FC<SingleRelatedPostsProps> = ({
  // relatedPosts = demoRelated,
  moreFromAuthorPosts = demoMoreFromAuthor,
  author= "",
  postData
}) => {
  const limitPosts = 4;
  const [authorPosts, setAuthorPosts] = useState<any>([]);
  const [relatedPosts, setRelatedPosts] = useState<any>([]);
  const postsCollectionRef = collection(doc(db, "posts", author), "posts");
  
  const getContent = async (snapshot: DocumentData) => {
    return await Promise.all(snapshot.docs.map(async (document: DocumentData): Promise<any> => {
      return {
        href: `/single/${document.get("userId")}/${document.id}`.split(" ").join('%'),
        id: document.id,
        postType: "standard",
        date: document.get("createdAt").toDate().toDateString(),
        featuredImage: document.get("image").downloadURL,
        like: {
          count: document.get("heartCount"),
          isLiked: await checkPostLiked(document.id)
        },
        bookmark: {count: 3502, isBookmarked: await checkBookmark(document.id)},
        ...document.data()
      };
    }))
  }

  const getAuthorPosts = () => {
    const q = query(
      postsCollectionRef,
      orderBy("createdAt", "desc"),
      limit(8)
    );
    getDocs(q).then(async (result) => {
      setAuthorPosts(await getContent(result));
    })
  }

  const getRelatedPosts = async () => {
    console.log(postData.categories)
    console.log(postData.tags)
    const temp = []
    let q;
    let q2;
    let result1;
    let result2;

    if(postData.categories.length > 0){
      q = query(
        collectionGroup(db, "posts"),
        where("categories", "array-contains", {...postData.categories[0]}),
        where("__name__", "!=", `posts/${postData.userId}/posts/${postData.id}`),
        limit(limitPosts)
      )
      result1 = await getDocs(q);
      temp.push(...await getContent(result1));
    }

    if (postData.tags.length > 0){
      q2 = query(
       collectionGroup(db, "posts"),
       where("tags", "array-contains-any", [...postData.tags]),
       where("__name__", "!=", `posts/${postData.userId}/posts/${postData.id}`),
       limit(limitPosts)
     )
     result2 = await getDocs(q2);
     temp.push(...await getContent(result2));
   }

    setRelatedPosts(Array.from(new Set(temp)));
  }

  useEffect(() => {
    getAuthorPosts();
    getRelatedPosts();
  }, [])

  return (
    <div className="relative bg-neutral-100 dark:bg-neutral-800 py-16 lg:py-28 mt-16 lg:mt-28">
      <div className="container">
        {relatedPosts.length > 0 &&
        <div>
          <Heading
            className="mb-10 text-neutral-900 dark:text-neutral-50"
            desc=""
          >
            Related posts
          </Heading>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
            {relatedPosts.map((post: any) => (
              <Card11 key={post.id} post={post} />
            ))}
          </div>
        </div>
        }

        {/* MORE FROM AUTHOR */}
        {authorPosts.length > 0 &&
          <div className="mt-20">
            <Heading
              className="mb-10 text-neutral-900 dark:text-neutral-50"
              desc=""
            >
              More from author
            </Heading>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
              {
                authorPosts.map((post: any) => (
                  <Card9 key={post.id} post={post} />))
              }
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default SingleRelatedPosts;
